
export enum BudgetStatus {
    TO_BUDGET = 'TO_BUDGET',
    IN_STUDY = 'IN_STUDY',
    IN_VERIFICATION = 'IN_VERIFICATION',
    PENDING_APPROVAL = 'PENDING_APPROVAL',
    ON_HOLD = 'ON_HOLD',
    BUDGET_REVIEW = 'BUDGET_REVIEW',
    AWAITING_CLIENT_DEFINITIONS = 'AWAITING_CLIENT_DEFINITIONS',
    ACCEPTED = 'ACCEPTED',
    NOT_INTERESTED = 'NOT_INTERESTED',
    NOT_ANSWERED = 'NOT_ANSWERED',
    REFUSED = 'REFUSED',
}
